<template>
  <div v-if="innerVisible" class="navbar-auth-dialog-wrap">
    <div class="navbar-auth-dialog-mask" @click="closeDialog" />
    <div
      class="navbar-auth-dialog"
      role="dialog"
      aria-modal="true"
      :style="{ width: dialogWidth }"
      @click.stop
    >
      <div class="navbar-auth-dialog-header">
        <div class="navbar-auth-dialog-title">{{ dialogTitle }}</div>
        <button
          type="button"
          class="navbar-auth-dialog-close"
          aria-label="关闭"
          @click="closeDialog"
        >
          ×
        </button>
      </div>

      <div class="navbar-auth-dialog-body">
        <template v-if="mode === 'member'">
          <el-tabs v-model="memberTab" @tab-click="onTabClick">
            <el-tab-pane label="登录" name="login">
              <compact-login-panel :embedded="true" @success="onLoginSuccess" @forgot="onForgot" />
            </el-tab-pane>
            <el-tab-pane label="注册" name="register">
              <user-register
                :embedded="true"
                @registered="memberTab = 'login'"
                @switch-login="memberTab = 'login'"
              />
            </el-tab-pane>
          </el-tabs>
        </template>

        <template v-else>
          <el-tabs v-model="proTab" @tab-click="onTabClick">
            <el-tab-pane label="登录" name="login">
              <compact-login-panel :embedded="true" @success="onLoginSuccess" @forgot="onForgot" />
            </el-tab-pane>
            <el-tab-pane label="造价师注册" name="engineer">
              <engineer-register
                :embedded="true"
                @registered="proTab = 'login'"
                @switch-login="proTab = 'login'"
              />
            </el-tab-pane>
            <el-tab-pane label="供应商注册" name="supplier">
              <supplier-register
                :embedded="true"
                @registered="proTab = 'login'"
                @switch-login="proTab = 'login'"
              />
            </el-tab-pane>
          </el-tabs>
        </template>
      </div>

      <div class="navbar-auth-footer">
        <el-button @click="closeDialog">关闭</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import CompactLoginPanel from '@/components/CompactLoginPanel.vue'
import UserRegister from '@/views/register/userRegister.vue'
import EngineerRegister from '@/views/register/engineerRegister.vue'
import SupplierRegister from '@/views/register/supplierRegister.vue'

export default {
  name: 'NavbarAuthDialog',
  components: {
    CompactLoginPanel,
    UserRegister,
    EngineerRegister,
    SupplierRegister
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'member',
      validator: v => v === 'member' || v === 'professional'
    }
  },
  data() {
    return {
      memberTab: 'login',
      proTab: 'login',
      prevBodyOverflow: '',
      keyHandler: null
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      }
    },
    dialogTitle() {
      return this.mode === 'member' ? '会员登录 / 注册' : '造价师 / 供应商 登录 / 注册'
    },
    dialogWidth() {
      return this.mode === 'professional' ? '640px' : '480px'
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.memberTab = 'login'
        this.proTab = 'login'
        this.lockBodyScroll()
        this.bindEscToClose()
      } else {
        this.unbindEscToClose()
        this.unlockBodyScroll()
      }
    }
  },
  mounted() {
    // 覆盖“初始就打开”的场景
    if (this.visible) {
      this.memberTab = 'login'
      this.proTab = 'login'
      this.lockBodyScroll()
      this.bindEscToClose()
    }
  },
  beforeDestroy() {
    // 防止异常情况下遗留事件/滚动锁
    this.unbindEscToClose()
    this.unlockBodyScroll()
  },
  methods: {
    closeDialog() {
      this.innerVisible = false
    },
    onLoginSuccess() {
      this.closeDialog()
      this.$emit('success')
    },
    onForgot() {
      this.closeDialog()
      this.$router.push('/forget')
    },
    onTabClick(tab) {
      this.$nextTick(() => {
        window.dispatchEvent(new Event('resize'))
      })
    },
    lockBodyScroll() {
      if (typeof document === 'undefined') return
      this.prevBodyOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'
      document.body.classList.add('navbar-auth-body-locked')
    },
    unlockBodyScroll() {
      if (typeof document === 'undefined') return
      document.body.style.overflow = this.prevBodyOverflow
      document.body.classList.remove('navbar-auth-body-locked')
    },
    bindEscToClose() {
      if (typeof document === 'undefined') return
      if (!this.keyHandler) {
        this.keyHandler = (e) => {
          if (e && e.key === 'Escape') this.closeDialog()
        }
      }
      document.addEventListener('keydown', this.keyHandler)
    },
    unbindEscToClose() {
      if (typeof document === 'undefined') return
      if (this.keyHandler) document.removeEventListener('keydown', this.keyHandler)
    }
  }
}
</script>

<style lang="scss">
.navbar-auth-dialog-wrap {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navbar-auth-dialog-mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
}

.navbar-auth-dialog {
  position: relative;
  z-index: 3001;
  max-height: 78vh;
  overflow: hidden;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
}

.navbar-auth-dialog-header {
  position: relative;
  padding: 16px 20px 8px;
  border-bottom: 1px solid #f0f0f0;
}

.navbar-auth-dialog-title {
  font-size: 16px;
  font-weight: 600;
  color: #222;
}

.navbar-auth-dialog-close {
  position: absolute;
  top: 12px;
  right: 18px;
  width: 28px;
  height: 28px;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: 22px;
  line-height: 28px;
  padding: 0;
}

.navbar-auth-dialog-body {
  padding: 8px 20px 24px;
  overflow-y: auto;
  max-height: 60vh;
}

/* 弹窗内图形验证码：加宽，高度与同行输入框一致；贴右、与输入框无间距 */
.navbar-auth-dialog-body .captcha-row {
  align-items: center;
  gap: 0 !important;
}

.navbar-auth-dialog-body .input-wrapper.captcha-row {
  gap: 0 !important;
  padding-right: 0;
}

.navbar-auth-dialog-body .captcha-row .el-input__inner {
  height: 40px !important;
  line-height: 40px !important;
  box-sizing: border-box;
}

.navbar-auth-dialog-body .input-wrapper.captcha-row .el-input__inner {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.navbar-auth-dialog-body .captcha-img {
  width: 140px !important;
  height: 40px !important;
  object-fit: cover;
  flex-shrink: 0;
}

.navbar-auth-footer {
  display: flex;
  justify-content: flex-end;
  padding: 0 20px 18px;
}

body.navbar-auth-body-locked {
  overflow: hidden;
}

/* 确保弹窗内 el-select 下拉层不被遮挡 */
.el-select-dropdown {
  z-index: 4001 !important;
}
</style>
